import { sql } from "@-/com.npmjs.drizzle-orm";
import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { graphemeDefinitionTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme-definition";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * HSK placement for a PRC-applicable grapheme definition.
 *
 * A definition may have more than one row because HSK 3.1 can introduce the same grapheme and
 * pronunciation at different levels for different parts of speech/use cases. Rows are absent when
 * the definition is outside every HSK version.
 */
export const graphemeDefinitionPrcDataTable = staticTable(
  "grapheme_definition_prc_data",
  {
    graphemeDefinitionId: integer("grapheme_definition_id")
      .notNull()
      .references(() => graphemeDefinitionTable.id),

    // HSK 2.0
    hsk2010Level: integer("hsk_2010_level"),

    // HSK 3.0
    hsk2021Level: integer("hsk_2021_level"),

    // HSK 3.1 (unofficial name)
    hsk2026Level: integer("hsk_2026_level"),
  },
  (table) => [
    index("grapheme_definition_prc_data_grapheme_definition_id_idx").on(table.graphemeDefinitionId),
    index("grapheme_definition_prc_data_hsk_2010_level_idx")
      .on(table.hsk2010Level)
      .where(sql`hsk_2010_level IS NOT NULL`),
    index("grapheme_definition_prc_data_hsk_2021_level_idx")
      .on(table.hsk2021Level)
      .where(sql`hsk_2021_level IS NOT NULL`),
    index("grapheme_definition_prc_data_hsk_2026_level_idx")
      .on(table.hsk2026Level)
      .where(sql`hsk_2026_level IS NOT NULL`),
  ],
);

export type GraphemeDefinitionPrcData = typeof graphemeDefinitionPrcDataTable.$inferSelect;
